import React, { Component } from "react";
import {
  View,
  StatusBar,
  Text,
  TouchableOpacity,
  Image,
} from "react-native-web";
import BackgroundImage from "../components/BackgroundImage";
import HeaderBar from "../components/HeaderBar";
import gql from "graphql-tag";
import { withRouter } from "react-router";
import { LoadingOverlay } from "../components/Overlay";
import localforage from "localforage";
import firebaseConfig from "../firebaseConfig.json";
import "firebase/messaging";
import firebase from "firebase/app";
import queryString from "query-string";
import { ApolloConsumer, Mutation, Query } from "react-apollo";
import { withI18n, translate } from "../libs/withI18n";
import { addNotification } from "../App";
import { handleError } from "../libs/errors";
import ApolloClient from "apollo-boost";

let urlValues;

class ClaimEmployee extends Component {
  state = {
    uniqueCode: "",
    Employee: null,
    session: {},
    loading: false,
    accountSession: null,
  };

  componentDidMount = async () => {
    let accountSession = await localforage.getItem(
      "accountSession",
      (err, val) => {
        if (err !== null) {
          return null;
        }
        return val;
      }
    );

    accountSession = JSON.parse(accountSession);
    // console.log(accountSession);
    this.setState({
      accountSession,
    });
  };

  refresh = () => {
    window.location.reload();
  };

  handleInputUniqueCode = (e) => {
    this.setState({
      uniqueCode: e.target.value,
    });
  };

  handleKeyDownUniqueCode = async (e) => {
    if (e.key === "Enter") {
      if (this.state.uniqueCode.length > 15) {
        return handleError({
          message: "Kode unik tidak valid!",
        });
      }
      this.setState({
        Employee: null,
        Errors: null,
        loading: true,
      });

      try {
        const response = await mwvClient.mutate({
          mutation: SEARCH_EMPLOYEE_BY_UNIQUE_CODE,
          variables: {
            uniqueCode: this.state.uniqueCode,
          },
          fetchPolicy: "no-cache",
        });

        // const response = await this.props.searchEmployeeByUniqueCode({
        //   variables: {
        //     uniqueCode: this.state.uniqueCode,
        //   },
        // });
        this.setState({
          Employee: response.data.searchEmployeeByUniqueCode,
          loading: false,
        });
      } catch (e) {
        this.setState({
          Errors: e,
          loading: false,
        });
      }
    }
  };

  handleSearch = async (e) => {
    if (this.state.uniqueCode.length > 15) {
      return handleError({
        message: "Kode unik tidak valid!",
      });
    }
    this.setState({
      Employee: null,
      Errors: null,
      loading: true,
    });

    try {
      const response = await mwvClient.mutate({
        mutation: SEARCH_EMPLOYEE_BY_UNIQUE_CODE,
        variables: {
          uniqueCode: this.state.uniqueCode,
        },
        fetchPolicy: "no-cache",
      });

      console.log(response.data);
      // const response = await this.props.searchEmployeeByUniqueCode({
      //   variables: {
      //     uniqueCode: this.state.uniqueCode,
      //   },
      // });
      this.setState({
        Employee: response.data.searchEmployeeByUniqueCode,
        loading: false,
      });
    } catch (e) {
      this.setState({
        Errors: e,
        loading: false,
      });
    }
  };

  handleClaim = async (e) => {
    if (e) e.preventDefault();
    this.setState({
      loading: true,
    });

    let userId = "";

    if (
      this.props.currentUser &&
      this.props.currentUser.data &&
      this.props.currentUser.data.currentUser &&
      this.props.currentUser.data.currentUser._id
    ) {
      userId = this.props.currentUser.data.currentUser._id;
    }
    try {
      let fcmToken = "";
      if (!firebase.apps.length) {
        // console.log("Initialize firebase...");
        firebase.initializeApp(firebaseConfig);
      }
      if (firebase.messaging.isSupported()) {
        const messaging = firebase.messaging();
        fcmToken = await messaging.getToken();
      }

      const response = await mwvClient.mutate({
        mutation: CLAIM_EMPLOYEE,
        variables: {
          userId,
          uniqueCode: this.state.uniqueCode,
          fcmToken,

          //#### Data From ST ALL
          _id: this.state.Employee._id,
          PREFIX: this.state.Employee.PREFIX,
          name: this.state.Employee.name,
          phone: this.state.Employee.phoneNumber,
          photoUrl: this.state.Employee.photoUrl
            ? this.state.Employee.photoUrl
            : "",
          regNumber: this.state.Employee.regNumber,
        },
      });
      const employee =
        response.data.claimEmployeeForAccount &&
        response.data.claimEmployeeForAccount.name
          ? response.data.claimEmployeeForAccount.name
          : "";
      this.setState({
        Employee: response.data.claimEmployeeForAccount,
        loading: false,
      });
      addNotification({
        title: "SUCCESS",
        message: `Berhasil klaim pegawai ${employee}`,
        level: "success",
      });
    } catch (e) {
      console.log(e);
      if (e.message.indexOf("Employee not found!") > -1) {
        this.setState({
          Employee: null,
          Errors: e.message,
          loading: false,
        });
      }
    }
  };

  render() {
    const { Employee, Errors, accountSession, loading } = this.state;
    urlValues = queryString.parse(this.props.location.search);
    return (
      <View style={{ flex: 1 }}>
        <div className="fixed-top">
          <StatusBar
            backgroundColor="#1696ff"
            barStyle="light-content"
            animated={true}
          />
        </div>
        <LoadingOverlay visible={loading} />
        <BackgroundImage />

        <div className="fixed-top">
          <HeaderBar
            title={
              <Text>
                <i
                  className="fa fa-user-plus"
                  style={{
                    fontSize: 20,
                  }}
                />{" "}
                {translate("Claim Employee")}
              </Text>
            }
            right={
              <TouchableOpacity
                onPress={() =>
                  this.props.history.push({
                    pathname: "/explore",
                  })
                }
              >
                <Text
                  style={{
                    paddingRight: 12,
                    paddingLeft: 20,
                    color: "white",
                    fontSize: 16,
                    paddingVertical: 2,
                  }}
                >
                  {/* <i
										className="fa fa-sync-alt"
										style={{
											fontSize: 20,
											marginBottom: 5
										}}
									/> */}
                  {translate("Kembali")}
                </Text>
              </TouchableOpacity>
            }
          />
        </div>
        <div
          className="card"
          style={{ borderRadius: "20px", margin: "auto 15px" }}
        >
          <div className="card-header">
            <Image
              style={{
                width: 140,
                height: 140,
                margin: "auto",
              }}
              source={require("../assets/call-center-female-caucasian.png")}
            />
          </div>
          <div className="card-body">
            <p className="text-center">
              {translate("Masukkan Kode Unik Pegawai Di Bawah Ini")}.
            </p>
            <div className="form-group">
              <input
                style={{ textAlign: "center" }}
                type="text"
                className="form-control"
                placeholder={`${translate("Masukkan kode unik")}...`}
                maxLength={15}
                onChange={this.handleInputUniqueCode}
                onKeyDown={this.handleKeyDownUniqueCode}
              />
              <button
                type="button"
                className="btn btn-block btn-primary mt-3"
                onClick={this.handleSearch}
              >
                <i className="fa fa-search" /> Cari
              </button>
            </div>

            {Employee ? (
              <div>
                <hr />
                <h6
                  className="text-bold text-center"
                  style={{ fontWeight: "bold" }}
                >
                  {translate("Pegawai ditemukan")}!
                </h6>
                <table className="w-100">
                  <thead>
                    <tr>
                      <th width="20%" />
                      <th width="5%" />
                      <th width="65%" />
                      <th width="10%" />
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{translate("Nama")}</td>
                      <td>:</td>
                      <td>{Employee.name}</td>
                    </tr>
                    <tr>
                      <td>{translate("NIS")}</td>
                      <td>:</td>
                      <td>{Employee.regNumber}</td>
                    </tr>
                  </tbody>
                </table>
                <hr />
                <button
                  onClick={this.handleClaim}
                  className="btn btn-primary btn-block"
                >
                  <i className="fa fa-user-check" /> {translate("Konfirmasi")}
                </button>
              </div>
            ) : Errors ? (
              <div className="text-center">
                <hr />
                <h6
                  className="text-bold text-center"
                  style={{ fontWeight: "bold" }}
                >
                  {translate("Pegawai tidak ditemukan")}!
                </h6>
                <Image
                  style={{
                    width: 140,
                    height: 140,
                    margin: "auto",
                  }}
                  source={require("../assets/user-remove-denied-male-asian.png")}
                />
              </div>
            ) : null}
          </div>
        </div>

        <div className="fixed-bottom">
          <TouchableOpacity
            onPress={() =>
              this.props.history.push({
                pathname: "/list_employees",
                search: `?sessionId=${accountSession._id}`,
              })
            }
          >
            <button
              type="button"
              // onClick={this.openFilterModal}
              style={{
                zIndex: 9999,
                backgroundColor: "#2e86de",
                height: 50,
                borderWidth: 0,
                borderRadius: 0,
                boxShadow: "0px -2px 5px 2px #ddd",
              }}
              className="btn btn-lg btn-primary btn-block"
            >
              <Text
                style={{
                  color: "white",
                  fontSize: 20,
                }}
              >
                <i className="fa fa-users" /> {translate("Daftar Pegawai")}
              </Text>
            </button>
          </TouchableOpacity>
        </div>
      </View>
    );
  }
}

const SEARCH_EMPLOYEE_BY_UNIQUE_CODE = gql`
  mutation searchEmployeeByUniqueCode($uniqueCode: String!) {
    searchEmployeeByUniqueCode(uniqueCode: $uniqueCode) {
      _id
      name
      regNumber
      PREFIX
      phoneNumber
      photoUrl
    }
  }
`;

const CLAIM_EMPLOYEE = gql`
  mutation claimEmployeeForAccount(
    $userId: String
    $uniqueCode: String!
    $fcmToken: String
    $_id: String!
    $PREFIX: String!
    $name: String!
    $phone: String!
    $photoUrl: String!
    $regNumber: String!
  ) {
    claimEmployeeForAccount(
      userId: $userId
      uniqueCode: $uniqueCode
      fcmToken: $fcmToken
      _id: $_id
      PREFIX: $PREFIX
      name: $name
      phone: $phone
      photoUrl: $photoUrl
      regNumber: $regNumber
    ) {
      _id
      name
      regNumber
    }
  }
`;

const QUERY = gql`
  query currentUser {
    currentUser {
      _id
      name
      email
      phone
      studentIds
      parentIds
      employeeIds
      prefixes
      roles
    }
  }
`;

const mwvClient = new ApolloClient({
  uri: "https://api.mwv.softwaresekolah.co.id/graphql",
  // uri: "http://localhost:9001/graphql",
});

export default withRouter(
  withI18n("claim_employee")((props) => {
    urlValues = queryString.parse(props.location.search);
    return (
      <ApolloConsumer>
        {(client) => (
          <Query query={QUERY}>
            {(currentUser) => (
              <ClaimEmployee
                {...props}
                // claimEmployeeForAccount={claimEmployeeForAccount}
                currentUser={currentUser}
              />
            )}
          </Query>
        )}
      </ApolloConsumer>
    );
  })
);
